const isRecord = (value: unknown): value is Record<string, unknown> =>
  typeof value === 'object' && value !== null;

const trimmedStringOrNull = (value: unknown): string | null => {
  if (typeof value !== 'string') return null;
  const trimmed = value.trim();
  return trimmed.length > 0 ? trimmed : null;
};

const stableContextValue = (value: unknown): unknown => {
  if (Array.isArray(value)) {
    return value.map(stableContextValue);
  }

  if (!isRecord(value)) {
    return value ?? null;
  }

  return Object.keys(value)
    .sort()
    .reduce<Record<string, unknown>>((normalized, key) => {
      normalized[key] = stableContextValue(value[key]);
      return normalized;
    }, {});
};

export const buildInvestorsContextKey = (user: unknown): string | null => {
  if (!isRecord(user)) {
    return null;
  }

  const context = {
    user_id: trimmedStringOrNull(user.id),
    client_id: trimmedStringOrNull(user.client_id),
    firm_data_advisor_id: trimmedStringOrNull(user.firm_data_advisor_id),
    firm_data_context: stableContextValue(user.firm_data_context),
  };

  const hasContext =
    context.user_id !== null ||
    context.client_id !== null ||
    context.firm_data_advisor_id !== null ||
    context.firm_data_context !== null;

  return hasContext ? JSON.stringify(context) : null;
};
